export default {
  methods: {
    // Display a stored (old-unit) SYP amount in the redenominated currency.
    // Amounts are still STORED (and sent to the backend / payment gateways) in
    // the OLD unit; we divide by 100 only for display (the "remove two zeros"
    // change), always with 2 decimals so fractional new pounds are not dropped
    // and totals reconcile. Returns "—" for null/empty. Does NOT append a
    // currency suffix (templates already add " SYP" / $t('business.syp')).
    formatMoney(v: any): string {
      if (v === null || v === undefined || v === "") return "—";
      const n = Number(v);
      if (isNaN(n)) return "—";
      return new Intl.NumberFormat("en", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(n / 100);
    },
    // Convert a user-entered NEW-unit amount back to the OLD storage unit before
    // POSTing to the backend (which stores/validates balances in old units).
    // Pair EVERY money input with this so stored values stay correct.
    toStoredAmount(v: any): number | null {
      if (v === null || v === undefined || v === "") return null;
      const n = Number(v);
      if (isNaN(n)) return null;
      return Math.round(n * 100);
    },
  },
};
